export default "__VITE_ASSET__QlQL35NW__"